/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * CGuard.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  CameraPlaybackResponse,
  CameraReachabilityResponse,
  CameraResponse,
  CamerasProxyLiveMediaParams,
  CamerasProxyPlaybackMediaParams,
  ChangeRequest,
  ChannelProtocolSettings,
  CreateCameraPlaybackRequest,
  GetV1CamerasParams,
  HttpValidationProblemDetails,
  ImportNvrCamerasRequest,
  ImportNvrCamerasResponse,
  JsonObject,
  NvrProbeResponse,
  PagedResultOfCameraResponse,
  ProbeNvrRequest,
  ProblemDetails,
  RegisterCameraRequest,
  SetCameraAiProfileRequest,
  SetCameraTierRequest,
  StopPlaybackRequest,
  StreamTokenResponse,
  UpdateCameraRequest,
} from '../../models';

import { cguardFetcher } from '../../../runtime/fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type camerasGetAnalyticRulesResponse200 = {
  data: void;
  status: 200;
};

export type camerasGetAnalyticRulesResponseSuccess = camerasGetAnalyticRulesResponse200 & {
  headers: Headers;
};

export type camerasGetAnalyticRulesResponse = camerasGetAnalyticRulesResponseSuccess;

export const getCamerasGetAnalyticRulesUrl = (id: string) => {
  return `/v1/cameras/${id}/analytic-rules`;
};

export const camerasGetAnalyticRules = async (
  id: string,
  options?: RequestInit,
): Promise<camerasGetAnalyticRulesResponse> => {
  return cguardFetcher<camerasGetAnalyticRulesResponse>(getCamerasGetAnalyticRulesUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasGetAnalyticRulesQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/analytic-rules`] as const;
};

export const getCamerasGetAnalyticRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetAnalyticRulesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetAnalyticRules>>> = ({
    signal,
  }) => camerasGetAnalyticRules(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetAnalyticRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetAnalyticRules>>
>;
export type CamerasGetAnalyticRulesQueryError = unknown;

export function useCamerasGetAnalyticRules<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
          TError,
          Awaited<ReturnType<typeof camerasGetAnalyticRules>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetAnalyticRules<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
          TError,
          Awaited<ReturnType<typeof camerasGetAnalyticRules>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetAnalyticRules<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCamerasGetAnalyticRules<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetAnalyticRulesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasGetAnalyticRulesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetAnalyticRulesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetAnalyticRules>>> = ({
    signal,
  }) => camerasGetAnalyticRules(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetAnalyticRulesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetAnalyticRules>>
>;
export type CamerasGetAnalyticRulesSuspenseQueryError = unknown;

export function useCamerasGetAnalyticRulesSuspense<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetAnalyticRulesSuspense<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetAnalyticRulesSuspense<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCamerasGetAnalyticRulesSuspense<
  TData = Awaited<ReturnType<typeof camerasGetAnalyticRules>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetAnalyticRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetAnalyticRulesSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type camerasPutAnalyticRulesResponse200 = {
  data: void;
  status: 200;
};

export type camerasPutAnalyticRulesResponseSuccess = camerasPutAnalyticRulesResponse200 & {
  headers: Headers;
};

export type camerasPutAnalyticRulesResponse = camerasPutAnalyticRulesResponseSuccess;

export const getCamerasPutAnalyticRulesUrl = (id: string) => {
  return `/v1/cameras/${id}/analytic-rules`;
};

export const camerasPutAnalyticRules = async (
  id: string,
  jsonObject: JsonObject,
  options?: RequestInit,
): Promise<camerasPutAnalyticRulesResponse> => {
  return cguardFetcher<camerasPutAnalyticRulesResponse>(getCamerasPutAnalyticRulesUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jsonObject),
  });
};

export const getCamerasPutAnalyticRulesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasPutAnalyticRules>>,
    TError,
    { id: string; data: JsonObject },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasPutAnalyticRules>>,
  TError,
  { id: string; data: JsonObject },
  TContext
> => {
  const mutationKey = ['camerasPutAnalyticRules'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasPutAnalyticRules>>,
    { id: string; data: JsonObject }
  > = (props) => {
    const { id, data } = props ?? {};

    return camerasPutAnalyticRules(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasPutAnalyticRulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasPutAnalyticRules>>
>;
export type CamerasPutAnalyticRulesMutationBody = JsonObject;
export type CamerasPutAnalyticRulesMutationError = unknown;

export const useCamerasPutAnalyticRules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasPutAnalyticRules>>,
      TError,
      { id: string; data: JsonObject },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasPutAnalyticRules>>,
  TError,
  { id: string; data: JsonObject },
  TContext
> => {
  return useMutation(getCamerasPutAnalyticRulesMutationOptions(options), queryClient);
};
export type postV1CamerasResponse201 = {
  data: CameraResponse;
  status: 201;
};

export type postV1CamerasResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1CamerasResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1CamerasResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1CamerasResponseSuccess = postV1CamerasResponse201 & {
  headers: Headers;
};
export type postV1CamerasResponseError = (
  | postV1CamerasResponse400
  | postV1CamerasResponse404
  | postV1CamerasResponse409
) & {
  headers: Headers;
};

export type postV1CamerasResponse = postV1CamerasResponseSuccess | postV1CamerasResponseError;

export const getPostV1CamerasUrl = () => {
  return `/v1/cameras`;
};

export const postV1Cameras = async (
  registerCameraRequest: RegisterCameraRequest,
  options?: RequestInit,
): Promise<postV1CamerasResponse> => {
  return cguardFetcher<postV1CamerasResponse>(getPostV1CamerasUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registerCameraRequest),
  });
};

export const getPostV1CamerasMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Cameras>>,
    TError,
    { data: RegisterCameraRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1Cameras>>,
  TError,
  { data: RegisterCameraRequest },
  TContext
> => {
  const mutationKey = ['postV1Cameras'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1Cameras>>,
    { data: RegisterCameraRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV1Cameras(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasMutationResult = NonNullable<Awaited<ReturnType<typeof postV1Cameras>>>;
export type PostV1CamerasMutationBody = RegisterCameraRequest;
export type PostV1CamerasMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1Cameras = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1Cameras>>,
      TError,
      { data: RegisterCameraRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1Cameras>>,
  TError,
  { data: RegisterCameraRequest },
  TContext
> => {
  return useMutation(getPostV1CamerasMutationOptions(options), queryClient);
};
export type getV1CamerasResponse200 = {
  data: PagedResultOfCameraResponse;
  status: 200;
};

export type getV1CamerasResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1CamerasResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1CamerasResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1CamerasResponseSuccess = getV1CamerasResponse200 & {
  headers: Headers;
};
export type getV1CamerasResponseError = (
  | getV1CamerasResponse400
  | getV1CamerasResponse404
  | getV1CamerasResponse409
) & {
  headers: Headers;
};

export type getV1CamerasResponse = getV1CamerasResponseSuccess | getV1CamerasResponseError;

export const getGetV1CamerasUrl = (params?: GetV1CamerasParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cameras?${stringifiedParams}` : `/v1/cameras`;
};

export const getV1Cameras = async (
  params?: GetV1CamerasParams,
  options?: RequestInit,
): Promise<getV1CamerasResponse> => {
  return cguardFetcher<getV1CamerasResponse>(getGetV1CamerasUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1CamerasQueryKey = (params?: GetV1CamerasParams) => {
  return [`/v1/cameras`, ...(params ? [params] : [])] as const;
};

export const getGetV1CamerasQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Cameras>>> = ({ signal }) =>
    getV1Cameras(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1Cameras>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasQueryResult = NonNullable<Awaited<ReturnType<typeof getV1Cameras>>>;
export type GetV1CamerasQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1Cameras<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: undefined | GetV1CamerasParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Cameras>>,
          TError,
          Awaited<ReturnType<typeof getV1Cameras>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1Cameras<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Cameras>>,
          TError,
          Awaited<ReturnType<typeof getV1Cameras>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1Cameras<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1Cameras<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1CamerasSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Cameras>>> = ({ signal }) =>
    getV1Cameras(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1Cameras>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getV1Cameras>>>;
export type GetV1CamerasSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1CamerasSuspense<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: undefined | GetV1CamerasParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasSuspense<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasSuspense<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1CamerasSuspense<
  TData = Awaited<ReturnType<typeof getV1Cameras>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1CamerasParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Cameras>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getV1CamerasIdResponse200 = {
  data: CameraResponse;
  status: 200;
};

export type getV1CamerasIdResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1CamerasIdResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1CamerasIdResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1CamerasIdResponseSuccess = getV1CamerasIdResponse200 & {
  headers: Headers;
};
export type getV1CamerasIdResponseError = (
  | getV1CamerasIdResponse400
  | getV1CamerasIdResponse404
  | getV1CamerasIdResponse409
) & {
  headers: Headers;
};

export type getV1CamerasIdResponse = getV1CamerasIdResponseSuccess | getV1CamerasIdResponseError;

export const getGetV1CamerasIdUrl = (id: string) => {
  return `/v1/cameras/${id}`;
};

export const getV1CamerasId = async (
  id: string,
  options?: RequestInit,
): Promise<getV1CamerasIdResponse> => {
  return cguardFetcher<getV1CamerasIdResponse>(getGetV1CamerasIdUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1CamerasIdQueryKey = (id: string) => {
  return [`/v1/cameras/${id}`] as const;
};

export const getGetV1CamerasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1CamerasId>>> = ({ signal }) =>
    getV1CamerasId(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1CamerasId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasIdQueryResult = NonNullable<Awaited<ReturnType<typeof getV1CamerasId>>>;
export type GetV1CamerasIdQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1CamerasId<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CamerasId>>,
          TError,
          Awaited<ReturnType<typeof getV1CamerasId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasId<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CamerasId>>,
          TError,
          Awaited<ReturnType<typeof getV1CamerasId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasId<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1CamerasId<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1CamerasIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1CamerasId>>> = ({ signal }) =>
    getV1CamerasId(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1CamerasId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1CamerasId>>
>;
export type GetV1CamerasIdSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1CamerasIdSuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdSuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdSuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1CamerasIdSuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type patchV1CamerasIdResponse200 = {
  data: void;
  status: 200;
};

export type patchV1CamerasIdResponseSuccess = patchV1CamerasIdResponse200 & {
  headers: Headers;
};

export type patchV1CamerasIdResponse = patchV1CamerasIdResponseSuccess;

export const getPatchV1CamerasIdUrl = (id: string) => {
  return `/v1/cameras/${id}`;
};

export const patchV1CamerasId = async (
  id: string,
  updateCameraRequest: UpdateCameraRequest,
  options?: RequestInit,
): Promise<patchV1CamerasIdResponse> => {
  return cguardFetcher<patchV1CamerasIdResponse>(getPatchV1CamerasIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCameraRequest),
  });
};

export const getPatchV1CamerasIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1CamerasId>>,
    TError,
    { id: string; data: UpdateCameraRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1CamerasId>>,
  TError,
  { id: string; data: UpdateCameraRequest },
  TContext
> => {
  const mutationKey = ['patchV1CamerasId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1CamerasId>>,
    { id: string; data: UpdateCameraRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchV1CamerasId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1CamerasIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1CamerasId>>
>;
export type PatchV1CamerasIdMutationBody = UpdateCameraRequest;
export type PatchV1CamerasIdMutationError = unknown;

export const usePatchV1CamerasId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1CamerasId>>,
      TError,
      { id: string; data: UpdateCameraRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1CamerasId>>,
  TError,
  { id: string; data: UpdateCameraRequest },
  TContext
> => {
  return useMutation(getPatchV1CamerasIdMutationOptions(options), queryClient);
};
export type postV1CamerasIdEnableResponse200 = {
  data: void;
  status: 200;
};

export type postV1CamerasIdEnableResponseSuccess = postV1CamerasIdEnableResponse200 & {
  headers: Headers;
};

export type postV1CamerasIdEnableResponse = postV1CamerasIdEnableResponseSuccess;

export const getPostV1CamerasIdEnableUrl = (id: string) => {
  return `/v1/cameras/${id}/enable`;
};

export const postV1CamerasIdEnable = async (
  id: string,
  options?: RequestInit,
): Promise<postV1CamerasIdEnableResponse> => {
  return cguardFetcher<postV1CamerasIdEnableResponse>(getPostV1CamerasIdEnableUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getPostV1CamerasIdEnableMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdEnable>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdEnable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdEnable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdEnable>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1CamerasIdEnable(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdEnable>>
>;

export type PostV1CamerasIdEnableMutationError = unknown;

export const usePostV1CamerasIdEnable = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdEnable>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdEnable>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1CamerasIdEnableMutationOptions(options), queryClient);
};
export type postV1CamerasIdDisableResponse200 = {
  data: void;
  status: 200;
};

export type postV1CamerasIdDisableResponseSuccess = postV1CamerasIdDisableResponse200 & {
  headers: Headers;
};

export type postV1CamerasIdDisableResponse = postV1CamerasIdDisableResponseSuccess;

export const getPostV1CamerasIdDisableUrl = (id: string) => {
  return `/v1/cameras/${id}/disable`;
};

export const postV1CamerasIdDisable = async (
  id: string,
  options?: RequestInit,
): Promise<postV1CamerasIdDisableResponse> => {
  return cguardFetcher<postV1CamerasIdDisableResponse>(getPostV1CamerasIdDisableUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getPostV1CamerasIdDisableMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdDisable>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdDisable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdDisable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdDisable>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1CamerasIdDisable(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdDisableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdDisable>>
>;

export type PostV1CamerasIdDisableMutationError = unknown;

export const usePostV1CamerasIdDisable = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdDisable>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdDisable>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1CamerasIdDisableMutationOptions(options), queryClient);
};
/**
 * @summary Deprecated: translate a legacy tier into a composed AI profile.
 */
export type postV1CamerasIdTierResponse204 = {
  data: void;
  status: 204;
};

export type postV1CamerasIdTierResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1CamerasIdTierResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1CamerasIdTierResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1CamerasIdTierResponseSuccess = postV1CamerasIdTierResponse204 & {
  headers: Headers;
};
export type postV1CamerasIdTierResponseError = (
  | postV1CamerasIdTierResponse400
  | postV1CamerasIdTierResponse404
  | postV1CamerasIdTierResponse409
) & {
  headers: Headers;
};

export type postV1CamerasIdTierResponse =
  | postV1CamerasIdTierResponseSuccess
  | postV1CamerasIdTierResponseError;

export const getPostV1CamerasIdTierUrl = (id: string) => {
  return `/v1/cameras/${id}/tier`;
};

export const postV1CamerasIdTier = async (
  id: string,
  setCameraTierRequest: SetCameraTierRequest,
  options?: RequestInit,
): Promise<postV1CamerasIdTierResponse> => {
  return cguardFetcher<postV1CamerasIdTierResponse>(getPostV1CamerasIdTierUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCameraTierRequest),
  });
};

export const getPostV1CamerasIdTierMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdTier>>,
    TError,
    { id: string; data: SetCameraTierRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdTier>>,
  TError,
  { id: string; data: SetCameraTierRequest },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdTier'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdTier>>,
    { id: string; data: SetCameraTierRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1CamerasIdTier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdTier>>
>;
export type PostV1CamerasIdTierMutationBody = SetCameraTierRequest;
export type PostV1CamerasIdTierMutationError = HttpValidationProblemDetails | ProblemDetails;

/**
 * @summary Deprecated: translate a legacy tier into a composed AI profile.
 */
export const usePostV1CamerasIdTier = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdTier>>,
      TError,
      { id: string; data: SetCameraTierRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdTier>>,
  TError,
  { id: string; data: SetCameraTierRequest },
  TContext
> => {
  return useMutation(getPostV1CamerasIdTierMutationOptions(options), queryClient);
};
export type postV1CamerasIdAiProfileResponse204 = {
  data: void;
  status: 204;
};

export type postV1CamerasIdAiProfileResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1CamerasIdAiProfileResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1CamerasIdAiProfileResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1CamerasIdAiProfileResponseSuccess = postV1CamerasIdAiProfileResponse204 & {
  headers: Headers;
};
export type postV1CamerasIdAiProfileResponseError = (
  | postV1CamerasIdAiProfileResponse400
  | postV1CamerasIdAiProfileResponse404
  | postV1CamerasIdAiProfileResponse409
) & {
  headers: Headers;
};

export type postV1CamerasIdAiProfileResponse =
  | postV1CamerasIdAiProfileResponseSuccess
  | postV1CamerasIdAiProfileResponseError;

export const getPostV1CamerasIdAiProfileUrl = (id: string) => {
  return `/v1/cameras/${id}/ai-profile`;
};

export const postV1CamerasIdAiProfile = async (
  id: string,
  setCameraAiProfileRequest: SetCameraAiProfileRequest,
  options?: RequestInit,
): Promise<postV1CamerasIdAiProfileResponse> => {
  return cguardFetcher<postV1CamerasIdAiProfileResponse>(getPostV1CamerasIdAiProfileUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCameraAiProfileRequest),
  });
};

export const getPostV1CamerasIdAiProfileMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>,
    TError,
    { id: string; data: SetCameraAiProfileRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>,
  TError,
  { id: string; data: SetCameraAiProfileRequest },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdAiProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>,
    { id: string; data: SetCameraAiProfileRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1CamerasIdAiProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdAiProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>
>;
export type PostV1CamerasIdAiProfileMutationBody = SetCameraAiProfileRequest;
export type PostV1CamerasIdAiProfileMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1CamerasIdAiProfile = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>,
      TError,
      { id: string; data: SetCameraAiProfileRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdAiProfile>>,
  TError,
  { id: string; data: SetCameraAiProfileRequest },
  TContext
> => {
  return useMutation(getPostV1CamerasIdAiProfileMutationOptions(options), queryClient);
};
export type postV1CamerasIdOfflineResponse204 = {
  data: void;
  status: 204;
};

export type postV1CamerasIdOfflineResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1CamerasIdOfflineResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1CamerasIdOfflineResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1CamerasIdOfflineResponseSuccess = postV1CamerasIdOfflineResponse204 & {
  headers: Headers;
};
export type postV1CamerasIdOfflineResponseError = (
  | postV1CamerasIdOfflineResponse400
  | postV1CamerasIdOfflineResponse404
  | postV1CamerasIdOfflineResponse409
) & {
  headers: Headers;
};

export type postV1CamerasIdOfflineResponse =
  | postV1CamerasIdOfflineResponseSuccess
  | postV1CamerasIdOfflineResponseError;

export const getPostV1CamerasIdOfflineUrl = (id: string) => {
  return `/v1/cameras/${id}/offline`;
};

export const postV1CamerasIdOffline = async (
  id: string,
  options?: RequestInit,
): Promise<postV1CamerasIdOfflineResponse> => {
  return cguardFetcher<postV1CamerasIdOfflineResponse>(getPostV1CamerasIdOfflineUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getPostV1CamerasIdOfflineMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdOffline>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdOffline>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdOffline'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdOffline>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1CamerasIdOffline(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdOfflineMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdOffline>>
>;

export type PostV1CamerasIdOfflineMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1CamerasIdOffline = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdOffline>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdOffline>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1CamerasIdOfflineMutationOptions(options), queryClient);
};
export type postV1CamerasIdOnlineResponse204 = {
  data: void;
  status: 204;
};

export type postV1CamerasIdOnlineResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1CamerasIdOnlineResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1CamerasIdOnlineResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1CamerasIdOnlineResponseSuccess = postV1CamerasIdOnlineResponse204 & {
  headers: Headers;
};
export type postV1CamerasIdOnlineResponseError = (
  | postV1CamerasIdOnlineResponse400
  | postV1CamerasIdOnlineResponse404
  | postV1CamerasIdOnlineResponse409
) & {
  headers: Headers;
};

export type postV1CamerasIdOnlineResponse =
  | postV1CamerasIdOnlineResponseSuccess
  | postV1CamerasIdOnlineResponseError;

export const getPostV1CamerasIdOnlineUrl = (id: string) => {
  return `/v1/cameras/${id}/online`;
};

export const postV1CamerasIdOnline = async (
  id: string,
  options?: RequestInit,
): Promise<postV1CamerasIdOnlineResponse> => {
  return cguardFetcher<postV1CamerasIdOnlineResponse>(getPostV1CamerasIdOnlineUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getPostV1CamerasIdOnlineMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdOnline>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdOnline>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdOnline'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdOnline>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1CamerasIdOnline(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdOnlineMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdOnline>>
>;

export type PostV1CamerasIdOnlineMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1CamerasIdOnline = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdOnline>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdOnline>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1CamerasIdOnlineMutationOptions(options), queryClient);
};
/**
 * @summary Probe an NVR through ONVIF with Hikvision fallback.
 */
export type camerasProbeNvrResponse200 = {
  data: NvrProbeResponse;
  status: 200;
};

export type camerasProbeNvrResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasProbeNvrResponseSuccess = camerasProbeNvrResponse200 & {
  headers: Headers;
};
export type camerasProbeNvrResponseError = camerasProbeNvrResponse502 & {
  headers: Headers;
};

export type camerasProbeNvrResponse = camerasProbeNvrResponseSuccess | camerasProbeNvrResponseError;

export const getCamerasProbeNvrUrl = () => {
  return `/v1/cameras/onboarding/probe`;
};

export const camerasProbeNvr = async (
  probeNvrRequest: ProbeNvrRequest,
  options?: RequestInit,
): Promise<camerasProbeNvrResponse> => {
  return cguardFetcher<camerasProbeNvrResponse>(getCamerasProbeNvrUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(probeNvrRequest),
  });
};

export const getCamerasProbeNvrMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasProbeNvr>>,
    TError,
    { data: ProbeNvrRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasProbeNvr>>,
  TError,
  { data: ProbeNvrRequest },
  TContext
> => {
  const mutationKey = ['camerasProbeNvr'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasProbeNvr>>,
    { data: ProbeNvrRequest }
  > = (props) => {
    const { data } = props ?? {};

    return camerasProbeNvr(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasProbeNvrMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasProbeNvr>>
>;
export type CamerasProbeNvrMutationBody = ProbeNvrRequest;
export type CamerasProbeNvrMutationError = ProblemDetails;

/**
 * @summary Probe an NVR through ONVIF with Hikvision fallback.
 */
export const useCamerasProbeNvr = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasProbeNvr>>,
      TError,
      { data: ProbeNvrRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasProbeNvr>>,
  TError,
  { data: ProbeNvrRequest },
  TContext
> => {
  return useMutation(getCamerasProbeNvrMutationOptions(options), queryClient);
};
/**
 * @summary Register selected channels from an opaque onboarding session.
 */
export type camerasImportNvrChannelsResponse200 = {
  data: ImportNvrCamerasResponse;
  status: 200;
};

export type camerasImportNvrChannelsResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasImportNvrChannelsResponseSuccess = camerasImportNvrChannelsResponse200 & {
  headers: Headers;
};
export type camerasImportNvrChannelsResponseError = camerasImportNvrChannelsResponse502 & {
  headers: Headers;
};

export type camerasImportNvrChannelsResponse =
  | camerasImportNvrChannelsResponseSuccess
  | camerasImportNvrChannelsResponseError;

export const getCamerasImportNvrChannelsUrl = () => {
  return `/v1/cameras/onboarding/import`;
};

export const camerasImportNvrChannels = async (
  importNvrCamerasRequest: ImportNvrCamerasRequest,
  options?: RequestInit,
): Promise<camerasImportNvrChannelsResponse> => {
  return cguardFetcher<camerasImportNvrChannelsResponse>(getCamerasImportNvrChannelsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importNvrCamerasRequest),
  });
};

export const getCamerasImportNvrChannelsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasImportNvrChannels>>,
    TError,
    { data: ImportNvrCamerasRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasImportNvrChannels>>,
  TError,
  { data: ImportNvrCamerasRequest },
  TContext
> => {
  const mutationKey = ['camerasImportNvrChannels'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasImportNvrChannels>>,
    { data: ImportNvrCamerasRequest }
  > = (props) => {
    const { data } = props ?? {};

    return camerasImportNvrChannels(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasImportNvrChannelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasImportNvrChannels>>
>;
export type CamerasImportNvrChannelsMutationBody = ImportNvrCamerasRequest;
export type CamerasImportNvrChannelsMutationError = ProblemDetails;

/**
 * @summary Register selected channels from an opaque onboarding session.
 */
export const useCamerasImportNvrChannels = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasImportNvrChannels>>,
      TError,
      { data: ImportNvrCamerasRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasImportNvrChannels>>,
  TError,
  { data: ImportNvrCamerasRequest },
  TContext
> => {
  return useMutation(getCamerasImportNvrChannelsMutationOptions(options), queryClient);
};
/**
 * Issues a short-lived grant plus the same-origin media URL for a recorded range of up to 30 minutes. The camera must lie within the caller's verified tenant scope.
 * @summary Create a bounded single-camera playback session.
 */
export type camerasIssuePlaybackResponse200 = {
  data: CameraPlaybackResponse;
  status: 200;
};

export type camerasIssuePlaybackResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type camerasIssuePlaybackResponse422 = {
  data: ProblemDetails;
  status: 422;
};

export type camerasIssuePlaybackResponseSuccess = camerasIssuePlaybackResponse200 & {
  headers: Headers;
};
export type camerasIssuePlaybackResponseError = (
  | camerasIssuePlaybackResponse403
  | camerasIssuePlaybackResponse422
) & {
  headers: Headers;
};

export type camerasIssuePlaybackResponse =
  | camerasIssuePlaybackResponseSuccess
  | camerasIssuePlaybackResponseError;

export const getCamerasIssuePlaybackUrl = (id: string) => {
  return `/v1/cameras/${id}/playback`;
};

export const camerasIssuePlayback = async (
  id: string,
  createCameraPlaybackRequest: CreateCameraPlaybackRequest,
  options?: RequestInit,
): Promise<camerasIssuePlaybackResponse> => {
  return cguardFetcher<camerasIssuePlaybackResponse>(getCamerasIssuePlaybackUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCameraPlaybackRequest),
  });
};

export const getCamerasIssuePlaybackMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasIssuePlayback>>,
    TError,
    { id: string; data: CreateCameraPlaybackRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasIssuePlayback>>,
  TError,
  { id: string; data: CreateCameraPlaybackRequest },
  TContext
> => {
  const mutationKey = ['camerasIssuePlayback'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasIssuePlayback>>,
    { id: string; data: CreateCameraPlaybackRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return camerasIssuePlayback(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasIssuePlaybackMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasIssuePlayback>>
>;
export type CamerasIssuePlaybackMutationBody = CreateCameraPlaybackRequest;
export type CamerasIssuePlaybackMutationError = ProblemDetails;

/**
 * @summary Create a bounded single-camera playback session.
 */
export const useCamerasIssuePlayback = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasIssuePlayback>>,
      TError,
      { id: string; data: CreateCameraPlaybackRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasIssuePlayback>>,
  TError,
  { id: string; data: CreateCameraPlaybackRequest },
  TContext
> => {
  return useMutation(getCamerasIssuePlaybackMutationOptions(options), queryClient);
};
export type camerasGetChannelProtocolResponse200 = {
  data: void;
  status: 200;
};

export type camerasGetChannelProtocolResponseSuccess = camerasGetChannelProtocolResponse200 & {
  headers: Headers;
};

export type camerasGetChannelProtocolResponse = camerasGetChannelProtocolResponseSuccess;

export const getCamerasGetChannelProtocolUrl = (id: string) => {
  return `/v1/cameras/${id}/protocol`;
};

export const camerasGetChannelProtocol = async (
  id: string,
  options?: RequestInit,
): Promise<camerasGetChannelProtocolResponse> => {
  return cguardFetcher<camerasGetChannelProtocolResponse>(getCamerasGetChannelProtocolUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasGetChannelProtocolQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/protocol`] as const;
};

export const getCamerasGetChannelProtocolQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetChannelProtocolQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetChannelProtocol>>> = ({
    signal,
  }) => camerasGetChannelProtocol(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetChannelProtocolQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetChannelProtocol>>
>;
export type CamerasGetChannelProtocolQueryError = unknown;

export function useCamerasGetChannelProtocol<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
          TError,
          Awaited<ReturnType<typeof camerasGetChannelProtocol>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetChannelProtocol<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
          TError,
          Awaited<ReturnType<typeof camerasGetChannelProtocol>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetChannelProtocol<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCamerasGetChannelProtocol<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetChannelProtocolQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasGetChannelProtocolSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetChannelProtocolQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetChannelProtocol>>> = ({
    signal,
  }) => camerasGetChannelProtocol(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetChannelProtocolSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetChannelProtocol>>
>;
export type CamerasGetChannelProtocolSuspenseQueryError = unknown;

export function useCamerasGetChannelProtocolSuspense<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetChannelProtocolSuspense<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetChannelProtocolSuspense<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCamerasGetChannelProtocolSuspense<
  TData = Awaited<ReturnType<typeof camerasGetChannelProtocol>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetChannelProtocol>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetChannelProtocolSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type camerasSetChannelProtocolResponse200 = {
  data: void;
  status: 200;
};

export type camerasSetChannelProtocolResponseSuccess = camerasSetChannelProtocolResponse200 & {
  headers: Headers;
};

export type camerasSetChannelProtocolResponse = camerasSetChannelProtocolResponseSuccess;

export const getCamerasSetChannelProtocolUrl = (id: string) => {
  return `/v1/cameras/${id}/protocol`;
};

export const camerasSetChannelProtocol = async (
  id: string,
  channelProtocolSettings: ChannelProtocolSettings,
  options?: RequestInit,
): Promise<camerasSetChannelProtocolResponse> => {
  return cguardFetcher<camerasSetChannelProtocolResponse>(getCamerasSetChannelProtocolUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(channelProtocolSettings),
  });
};

export const getCamerasSetChannelProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasSetChannelProtocol>>,
    TError,
    { id: string; data: ChannelProtocolSettings },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasSetChannelProtocol>>,
  TError,
  { id: string; data: ChannelProtocolSettings },
  TContext
> => {
  const mutationKey = ['camerasSetChannelProtocol'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasSetChannelProtocol>>,
    { id: string; data: ChannelProtocolSettings }
  > = (props) => {
    const { id, data } = props ?? {};

    return camerasSetChannelProtocol(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasSetChannelProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasSetChannelProtocol>>
>;
export type CamerasSetChannelProtocolMutationBody = ChannelProtocolSettings;
export type CamerasSetChannelProtocolMutationError = unknown;

export const useCamerasSetChannelProtocol = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasSetChannelProtocol>>,
      TError,
      { id: string; data: ChannelProtocolSettings },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasSetChannelProtocol>>,
  TError,
  { id: string; data: ChannelProtocolSettings },
  TContext
> => {
  return useMutation(getCamerasSetChannelProtocolMutationOptions(options), queryClient);
};
export type camerasStopPlaybackResponse200 = {
  data: void;
  status: 200;
};

export type camerasStopPlaybackResponseSuccess = camerasStopPlaybackResponse200 & {
  headers: Headers;
};

export type camerasStopPlaybackResponse = camerasStopPlaybackResponseSuccess;

export const getCamerasStopPlaybackUrl = () => {
  return `/v1/cameras/playback/stop`;
};

export const camerasStopPlayback = async (
  stopPlaybackRequest: StopPlaybackRequest,
  options?: RequestInit,
): Promise<camerasStopPlaybackResponse> => {
  return cguardFetcher<camerasStopPlaybackResponse>(getCamerasStopPlaybackUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stopPlaybackRequest),
  });
};

export const getCamerasStopPlaybackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasStopPlayback>>,
    TError,
    { data: StopPlaybackRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasStopPlayback>>,
  TError,
  { data: StopPlaybackRequest },
  TContext
> => {
  const mutationKey = ['camerasStopPlayback'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasStopPlayback>>,
    { data: StopPlaybackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return camerasStopPlayback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasStopPlaybackMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasStopPlayback>>
>;
export type CamerasStopPlaybackMutationBody = StopPlaybackRequest;
export type CamerasStopPlaybackMutationError = unknown;

export const useCamerasStopPlayback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasStopPlayback>>,
      TError,
      { data: StopPlaybackRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasStopPlayback>>,
  TError,
  { data: StopPlaybackRequest },
  TContext
> => {
  return useMutation(getCamerasStopPlaybackMutationOptions(options), queryClient);
};
/**
 * @summary Proxy signed playback media from the edge.
 */
export type camerasProxyPlaybackMediaResponse200 = {
  data: void;
  status: 200;
};

export type camerasProxyPlaybackMediaResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type camerasProxyPlaybackMediaResponseSuccess = camerasProxyPlaybackMediaResponse200 & {
  headers: Headers;
};
export type camerasProxyPlaybackMediaResponseError = camerasProxyPlaybackMediaResponse401 & {
  headers: Headers;
};

export type camerasProxyPlaybackMediaResponse =
  | camerasProxyPlaybackMediaResponseSuccess
  | camerasProxyPlaybackMediaResponseError;

export const getCamerasProxyPlaybackMediaUrl = (params: CamerasProxyPlaybackMediaParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/cameras/playback/media?${stringifiedParams}`
    : `/v1/cameras/playback/media`;
};

export const camerasProxyPlaybackMedia = async (
  params: CamerasProxyPlaybackMediaParams,
  options?: RequestInit,
): Promise<camerasProxyPlaybackMediaResponse> => {
  return cguardFetcher<camerasProxyPlaybackMediaResponse>(getCamerasProxyPlaybackMediaUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasProxyPlaybackMediaQueryKey = (params?: CamerasProxyPlaybackMediaParams) => {
  return [`/v1/cameras/playback/media`, ...(params ? [params] : [])] as const;
};

export const getCamerasProxyPlaybackMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasProxyPlaybackMediaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>> = ({
    signal,
  }) => camerasProxyPlaybackMedia(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasProxyPlaybackMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>
>;
export type CamerasProxyPlaybackMediaQueryError = ProblemDetails;

export function useCamerasProxyPlaybackMedia<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
          TError,
          Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyPlaybackMedia<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
          TError,
          Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyPlaybackMedia<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Proxy signed playback media from the edge.
 */

export function useCamerasProxyPlaybackMedia<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProxyPlaybackMediaQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasProxyPlaybackMediaSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasProxyPlaybackMediaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>> = ({
    signal,
  }) => camerasProxyPlaybackMedia(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasProxyPlaybackMediaSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>
>;
export type CamerasProxyPlaybackMediaSuspenseQueryError = ProblemDetails;

export function useCamerasProxyPlaybackMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyPlaybackMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyPlaybackMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Proxy signed playback media from the edge.
 */

export function useCamerasProxyPlaybackMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>,
  TError = ProblemDetails,
>(
  params: CamerasProxyPlaybackMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyPlaybackMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProxyPlaybackMediaSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Proxy a signed LL-HLS playlist or media asset from the edge.
 */
export type camerasProxyLiveMediaResponse200 = {
  data: void;
  status: 200;
};

export type camerasProxyLiveMediaResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type camerasProxyLiveMediaResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasProxyLiveMediaResponseSuccess = camerasProxyLiveMediaResponse200 & {
  headers: Headers;
};
export type camerasProxyLiveMediaResponseError = (
  | camerasProxyLiveMediaResponse401
  | camerasProxyLiveMediaResponse502
) & {
  headers: Headers;
};

export type camerasProxyLiveMediaResponse =
  | camerasProxyLiveMediaResponseSuccess
  | camerasProxyLiveMediaResponseError;

export const getCamerasProxyLiveMediaUrl = (
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/cameras/live/${cameraId}/${assetPath}?${stringifiedParams}`
    : `/v1/cameras/live/${cameraId}/${assetPath}`;
};

export const camerasProxyLiveMedia = async (
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: RequestInit,
): Promise<camerasProxyLiveMediaResponse> => {
  return cguardFetcher<camerasProxyLiveMediaResponse>(
    getCamerasProxyLiveMediaUrl(cameraId, assetPath, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getCamerasProxyLiveMediaQueryKey = (
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
) => {
  return [`/v1/cameras/live/${cameraId}/${assetPath}`, ...(params ? [params] : [])] as const;
};

export const getCamerasProxyLiveMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCamerasProxyLiveMediaQueryKey(cameraId, assetPath, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProxyLiveMedia>>> = ({ signal }) =>
    camerasProxyLiveMedia(cameraId, assetPath, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(cameraId && assetPath),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CamerasProxyLiveMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProxyLiveMedia>>
>;
export type CamerasProxyLiveMediaQueryError = ProblemDetails;

export function useCamerasProxyLiveMedia<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params: undefined | CamerasProxyLiveMediaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
          TError,
          Awaited<ReturnType<typeof camerasProxyLiveMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyLiveMedia<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
          TError,
          Awaited<ReturnType<typeof camerasProxyLiveMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyLiveMedia<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Proxy a signed LL-HLS playlist or media asset from the edge.
 */

export function useCamerasProxyLiveMedia<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProxyLiveMediaQueryOptions(cameraId, assetPath, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasProxyLiveMediaSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCamerasProxyLiveMediaQueryKey(cameraId, assetPath, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProxyLiveMedia>>> = ({ signal }) =>
    camerasProxyLiveMedia(cameraId, assetPath, params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasProxyLiveMediaSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProxyLiveMedia>>
>;
export type CamerasProxyLiveMediaSuspenseQueryError = ProblemDetails;

export function useCamerasProxyLiveMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params: undefined | CamerasProxyLiveMediaParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyLiveMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProxyLiveMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Proxy a signed LL-HLS playlist or media asset from the edge.
 */

export function useCamerasProxyLiveMediaSuspense<
  TData = Awaited<ReturnType<typeof camerasProxyLiveMedia>>,
  TError = ProblemDetails,
>(
  cameraId: string,
  assetPath: string,
  params?: CamerasProxyLiveMediaParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProxyLiveMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProxyLiveMediaSuspenseQueryOptions(
    cameraId,
    assetPath,
    params,
    options,
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Describe the configured RTSP stream through its edge relay.
 */
export type camerasProbeReachabilityResponse200 = {
  data: CameraReachabilityResponse;
  status: 200;
};

export type camerasProbeReachabilityResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type camerasProbeReachabilityResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type camerasProbeReachabilityResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type camerasProbeReachabilityResponseSuccess = camerasProbeReachabilityResponse200 & {
  headers: Headers;
};
export type camerasProbeReachabilityResponseError = (
  | camerasProbeReachabilityResponse400
  | camerasProbeReachabilityResponse404
  | camerasProbeReachabilityResponse409
) & {
  headers: Headers;
};

export type camerasProbeReachabilityResponse =
  | camerasProbeReachabilityResponseSuccess
  | camerasProbeReachabilityResponseError;

export const getCamerasProbeReachabilityUrl = (id: string) => {
  return `/v1/cameras/${id}/reachability`;
};

export const camerasProbeReachability = async (
  id: string,
  options?: RequestInit,
): Promise<camerasProbeReachabilityResponse> => {
  return cguardFetcher<camerasProbeReachabilityResponse>(getCamerasProbeReachabilityUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasProbeReachabilityQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/reachability`] as const;
};

export const getCamerasProbeReachabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasProbeReachabilityQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProbeReachability>>> = ({
    signal,
  }) => camerasProbeReachability(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasProbeReachability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasProbeReachabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProbeReachability>>
>;
export type CamerasProbeReachabilityQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useCamerasProbeReachability<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProbeReachability>>,
          TError,
          Awaited<ReturnType<typeof camerasProbeReachability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProbeReachability<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasProbeReachability>>,
          TError,
          Awaited<ReturnType<typeof camerasProbeReachability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProbeReachability<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Describe the configured RTSP stream through its edge relay.
 */

export function useCamerasProbeReachability<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProbeReachabilityQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasProbeReachabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasProbeReachabilityQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasProbeReachability>>> = ({
    signal,
  }) => camerasProbeReachability(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasProbeReachability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasProbeReachabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasProbeReachability>>
>;
export type CamerasProbeReachabilitySuspenseQueryError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export function useCamerasProbeReachabilitySuspense<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProbeReachabilitySuspense<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasProbeReachabilitySuspense<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Describe the configured RTSP stream through its edge relay.
 */

export function useCamerasProbeReachabilitySuspense<
  TData = Awaited<ReturnType<typeof camerasProbeReachability>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasProbeReachability>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasProbeReachabilitySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Proxies a single JPEG keyframe from the edge appliance's go2rtc instance for the specified camera. Cached for 1s per camera to rate-limit auditor refresh storms. Returns 503 with code edge_snapshot_unavailable if the edge cannot deliver a frame. The camera must lie within the caller's verified tenant scope.
 * @summary Live JPEG snapshot from the edge appliance.
 */
export type camerasGetSnapshotResponse200 = {
  data: void;
  status: 200;
};

export type camerasGetSnapshotResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type camerasGetSnapshotResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type camerasGetSnapshotResponse503 = {
  data: ProblemDetails;
  status: 503;
};

export type camerasGetSnapshotResponseSuccess = camerasGetSnapshotResponse200 & {
  headers: Headers;
};
export type camerasGetSnapshotResponseError = (
  | camerasGetSnapshotResponse403
  | camerasGetSnapshotResponse404
  | camerasGetSnapshotResponse503
) & {
  headers: Headers;
};

export type camerasGetSnapshotResponse =
  | camerasGetSnapshotResponseSuccess
  | camerasGetSnapshotResponseError;

export const getCamerasGetSnapshotUrl = (id: string) => {
  return `/v1/cameras/${id}/snapshot`;
};

export const camerasGetSnapshot = async (
  id: string,
  options?: RequestInit,
): Promise<camerasGetSnapshotResponse> => {
  return cguardFetcher<camerasGetSnapshotResponse>(getCamerasGetSnapshotUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasGetSnapshotQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/snapshot`] as const;
};

export const getCamerasGetSnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetSnapshotQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetSnapshot>>> = ({ signal }) =>
    camerasGetSnapshot(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasGetSnapshot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetSnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetSnapshot>>
>;
export type CamerasGetSnapshotQueryError = ProblemDetails;

export function useCamerasGetSnapshot<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetSnapshot>>,
          TError,
          Awaited<ReturnType<typeof camerasGetSnapshot>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetSnapshot<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasGetSnapshot>>,
          TError,
          Awaited<ReturnType<typeof camerasGetSnapshot>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetSnapshot<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live JPEG snapshot from the edge appliance.
 */

export function useCamerasGetSnapshot<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetSnapshotQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasGetSnapshotSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasGetSnapshotQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasGetSnapshot>>> = ({ signal }) =>
    camerasGetSnapshot(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasGetSnapshot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasGetSnapshotSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasGetSnapshot>>
>;
export type CamerasGetSnapshotSuspenseQueryError = ProblemDetails;

export function useCamerasGetSnapshotSuspense<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetSnapshotSuspense<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasGetSnapshotSuspense<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live JPEG snapshot from the edge appliance.
 */

export function useCamerasGetSnapshotSuspense<
  TData = Awaited<ReturnType<typeof camerasGetSnapshot>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasGetSnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasGetSnapshotSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Issues a short-lived (60s) signed token plus the LL-HLS playlist URL the browser should fetch through the central same-origin media proxy. The camera must lie within the caller's verified tenant scope; SIRA-side audit principals remain bounded by their persisted scope grants per ADR-0048 and ADR-0014.
 * @summary Mint a 60-second LL-HLS stream token.
 */
export type camerasIssueStreamTokenResponse200 = {
  data: StreamTokenResponse;
  status: 200;
};

export type camerasIssueStreamTokenResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type camerasIssueStreamTokenResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type camerasIssueStreamTokenResponseSuccess = camerasIssueStreamTokenResponse200 & {
  headers: Headers;
};
export type camerasIssueStreamTokenResponseError = (
  | camerasIssueStreamTokenResponse403
  | camerasIssueStreamTokenResponse404
) & {
  headers: Headers;
};

export type camerasIssueStreamTokenResponse =
  | camerasIssueStreamTokenResponseSuccess
  | camerasIssueStreamTokenResponseError;

export const getCamerasIssueStreamTokenUrl = (id: string) => {
  return `/v1/cameras/${id}/stream-token`;
};

export const camerasIssueStreamToken = async (
  id: string,
  options?: RequestInit,
): Promise<camerasIssueStreamTokenResponse> => {
  return cguardFetcher<camerasIssueStreamTokenResponse>(getCamerasIssueStreamTokenUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasIssueStreamTokenQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/stream-token`] as const;
};

export const getCamerasIssueStreamTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasIssueStreamTokenQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasIssueStreamToken>>> = ({
    signal,
  }) => camerasIssueStreamToken(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasIssueStreamToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasIssueStreamTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasIssueStreamToken>>
>;
export type CamerasIssueStreamTokenQueryError = ProblemDetails;

export function useCamerasIssueStreamToken<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasIssueStreamToken>>,
          TError,
          Awaited<ReturnType<typeof camerasIssueStreamToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasIssueStreamToken<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasIssueStreamToken>>,
          TError,
          Awaited<ReturnType<typeof camerasIssueStreamToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasIssueStreamToken<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Mint a 60-second LL-HLS stream token.
 */

export function useCamerasIssueStreamToken<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasIssueStreamTokenQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasIssueStreamTokenSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasIssueStreamTokenQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasIssueStreamToken>>> = ({
    signal,
  }) => camerasIssueStreamToken(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasIssueStreamToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasIssueStreamTokenSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasIssueStreamToken>>
>;
export type CamerasIssueStreamTokenSuspenseQueryError = ProblemDetails;

export function useCamerasIssueStreamTokenSuspense<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasIssueStreamTokenSuspense<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasIssueStreamTokenSuspense<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Mint a 60-second LL-HLS stream token.
 */

export function useCamerasIssueStreamTokenSuspense<
  TData = Awaited<ReturnType<typeof camerasIssueStreamToken>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasIssueStreamToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasIssueStreamTokenSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorizes the camera under the caller's verified tenant scope before forwarding an SDP offer to the private MediaMTX service. Returns only a same-origin opaque session handle in Location.
 * @summary Create an authorized central WHEP session.
 */
export type camerasCreateWhepSessionResponse201 = {
  data: void;
  status: 201;
};

export type camerasCreateWhepSessionResponse400 = {
  data: ProblemDetails;
  status: 400;
};

export type camerasCreateWhepSessionResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type camerasCreateWhepSessionResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type camerasCreateWhepSessionResponse422 = {
  data: ProblemDetails;
  status: 422;
};

export type camerasCreateWhepSessionResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasCreateWhepSessionResponseSuccess = camerasCreateWhepSessionResponse201 & {
  headers: Headers;
};
export type camerasCreateWhepSessionResponseError = (
  | camerasCreateWhepSessionResponse400
  | camerasCreateWhepSessionResponse403
  | camerasCreateWhepSessionResponse404
  | camerasCreateWhepSessionResponse422
  | camerasCreateWhepSessionResponse502
) & {
  headers: Headers;
};

export type camerasCreateWhepSessionResponse =
  | camerasCreateWhepSessionResponseSuccess
  | camerasCreateWhepSessionResponseError;

export const getCamerasCreateWhepSessionUrl = (cameraId: string) => {
  return `/v1/cameras/${cameraId}/whep`;
};

export const camerasCreateWhepSession = async (
  cameraId: string,
  camerasCreateWhepSessionBody: string,
  options?: RequestInit,
): Promise<camerasCreateWhepSessionResponse> => {
  return cguardFetcher<camerasCreateWhepSessionResponse>(getCamerasCreateWhepSessionUrl(cameraId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/sdp', ...options?.headers },
    body: JSON.stringify(camerasCreateWhepSessionBody),
  });
};

export const getCamerasCreateWhepSessionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasCreateWhepSession>>,
    TError,
    { cameraId: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasCreateWhepSession>>,
  TError,
  { cameraId: string; data: string },
  TContext
> => {
  const mutationKey = ['camerasCreateWhepSession'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasCreateWhepSession>>,
    { cameraId: string; data: string }
  > = (props) => {
    const { cameraId, data } = props ?? {};

    return camerasCreateWhepSession(cameraId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasCreateWhepSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasCreateWhepSession>>
>;
export type CamerasCreateWhepSessionMutationBody = string;
export type CamerasCreateWhepSessionMutationError = ProblemDetails;

/**
 * @summary Create an authorized central WHEP session.
 */
export const useCamerasCreateWhepSession = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasCreateWhepSession>>,
      TError,
      { cameraId: string; data: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasCreateWhepSession>>,
  TError,
  { cameraId: string; data: string },
  TContext
> => {
  return useMutation(getCamerasCreateWhepSessionMutationOptions(options), queryClient);
};
/**
 * @summary Forward authenticated ICE candidates to a WHEP session.
 */
export type camerasTrickleWhepSessionResponse204 = {
  data: void;
  status: 204;
};

export type camerasTrickleWhepSessionResponse400 = {
  data: ProblemDetails;
  status: 400;
};

export type camerasTrickleWhepSessionResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type camerasTrickleWhepSessionResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasTrickleWhepSessionResponseSuccess = camerasTrickleWhepSessionResponse204 & {
  headers: Headers;
};
export type camerasTrickleWhepSessionResponseError = (
  | camerasTrickleWhepSessionResponse400
  | camerasTrickleWhepSessionResponse401
  | camerasTrickleWhepSessionResponse502
) & {
  headers: Headers;
};

export type camerasTrickleWhepSessionResponse =
  | camerasTrickleWhepSessionResponseSuccess
  | camerasTrickleWhepSessionResponseError;

export const getCamerasTrickleWhepSessionUrl = (handle: string) => {
  return `/v1/cameras/whep-sessions/${handle}`;
};

export const camerasTrickleWhepSession = async (
  handle: string,
  camerasTrickleWhepSessionBody: string,
  options?: RequestInit,
): Promise<camerasTrickleWhepSessionResponse> => {
  return cguardFetcher<camerasTrickleWhepSessionResponse>(getCamerasTrickleWhepSessionUrl(handle), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/trickle-ice-sdpfrag', ...options?.headers },
    body: JSON.stringify(camerasTrickleWhepSessionBody),
  });
};

export const getCamerasTrickleWhepSessionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasTrickleWhepSession>>,
    TError,
    { handle: string; data: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasTrickleWhepSession>>,
  TError,
  { handle: string; data: string },
  TContext
> => {
  const mutationKey = ['camerasTrickleWhepSession'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasTrickleWhepSession>>,
    { handle: string; data: string }
  > = (props) => {
    const { handle, data } = props ?? {};

    return camerasTrickleWhepSession(handle, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasTrickleWhepSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasTrickleWhepSession>>
>;
export type CamerasTrickleWhepSessionMutationBody = string;
export type CamerasTrickleWhepSessionMutationError = ProblemDetails;

/**
 * @summary Forward authenticated ICE candidates to a WHEP session.
 */
export const useCamerasTrickleWhepSession = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasTrickleWhepSession>>,
      TError,
      { handle: string; data: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasTrickleWhepSession>>,
  TError,
  { handle: string; data: string },
  TContext
> => {
  return useMutation(getCamerasTrickleWhepSessionMutationOptions(options), queryClient);
};
/**
 * @summary Tear down an authenticated central WHEP session.
 */
export type camerasDeleteWhepSessionResponse204 = {
  data: void;
  status: 204;
};

export type camerasDeleteWhepSessionResponse401 = {
  data: ProblemDetails;
  status: 401;
};

export type camerasDeleteWhepSessionResponse502 = {
  data: ProblemDetails;
  status: 502;
};

export type camerasDeleteWhepSessionResponseSuccess = camerasDeleteWhepSessionResponse204 & {
  headers: Headers;
};
export type camerasDeleteWhepSessionResponseError = (
  | camerasDeleteWhepSessionResponse401
  | camerasDeleteWhepSessionResponse502
) & {
  headers: Headers;
};

export type camerasDeleteWhepSessionResponse =
  | camerasDeleteWhepSessionResponseSuccess
  | camerasDeleteWhepSessionResponseError;

export const getCamerasDeleteWhepSessionUrl = (handle: string) => {
  return `/v1/cameras/whep-sessions/${handle}`;
};

export const camerasDeleteWhepSession = async (
  handle: string,
  options?: RequestInit,
): Promise<camerasDeleteWhepSessionResponse> => {
  return cguardFetcher<camerasDeleteWhepSessionResponse>(getCamerasDeleteWhepSessionUrl(handle), {
    ...options,
    method: 'DELETE',
  });
};

export const getCamerasDeleteWhepSessionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof camerasDeleteWhepSession>>,
    TError,
    { handle: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof camerasDeleteWhepSession>>,
  TError,
  { handle: string },
  TContext
> => {
  const mutationKey = ['camerasDeleteWhepSession'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof camerasDeleteWhepSession>>,
    { handle: string }
  > = (props) => {
    const { handle } = props ?? {};

    return camerasDeleteWhepSession(handle, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CamerasDeleteWhepSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof camerasDeleteWhepSession>>
>;

export type CamerasDeleteWhepSessionMutationError = ProblemDetails;

/**
 * @summary Tear down an authenticated central WHEP session.
 */
export const useCamerasDeleteWhepSession = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof camerasDeleteWhepSession>>,
      TError,
      { handle: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof camerasDeleteWhepSession>>,
  TError,
  { handle: string },
  TContext
> => {
  return useMutation(getCamerasDeleteWhepSessionMutationOptions(options), queryClient);
};
/**
 * Server-Sent Events stream forwarding health-lite snapshots (brightness / contrast / tamper / frozen / stalled / last-seen) from the edge MQTT broker. Stream diagnostics (FPS, bitrate, codec, keyframe gap, drops) are deliberately not labelled — the edge publisher does not emit them today. The camera must lie within the caller's verified tenant scope.
 * @summary SSE stream of camera health-lite snapshots.
 */
export type camerasStreamHealthLiteResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type camerasStreamHealthLiteResponse404 = {
  data: ProblemDetails;
  status: 404;
};
export type camerasStreamHealthLiteResponseError = (
  | camerasStreamHealthLiteResponse403
  | camerasStreamHealthLiteResponse404
) & {
  headers: Headers;
};

export type camerasStreamHealthLiteResponse = camerasStreamHealthLiteResponseError;

export const getCamerasStreamHealthLiteUrl = (id: string) => {
  return `/v1/cameras/${id}/health`;
};

export const camerasStreamHealthLite = async (
  id: string,
  options?: RequestInit,
): Promise<camerasStreamHealthLiteResponse> => {
  return cguardFetcher<camerasStreamHealthLiteResponse>(getCamerasStreamHealthLiteUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getCamerasStreamHealthLiteQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/health`] as const;
};

export const getCamerasStreamHealthLiteQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasStreamHealthLiteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasStreamHealthLite>>> = ({
    signal,
  }) => camerasStreamHealthLite(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof camerasStreamHealthLite>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasStreamHealthLiteQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasStreamHealthLite>>
>;
export type CamerasStreamHealthLiteQueryError = ProblemDetails;

export function useCamerasStreamHealthLite<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasStreamHealthLite>>,
          TError,
          Awaited<ReturnType<typeof camerasStreamHealthLite>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasStreamHealthLite<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof camerasStreamHealthLite>>,
          TError,
          Awaited<ReturnType<typeof camerasStreamHealthLite>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasStreamHealthLite<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary SSE stream of camera health-lite snapshots.
 */

export function useCamerasStreamHealthLite<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasStreamHealthLiteQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCamerasStreamHealthLiteSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCamerasStreamHealthLiteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof camerasStreamHealthLite>>> = ({
    signal,
  }) => camerasStreamHealthLite(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof camerasStreamHealthLite>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CamerasStreamHealthLiteSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof camerasStreamHealthLite>>
>;
export type CamerasStreamHealthLiteSuspenseQueryError = ProblemDetails;

export function useCamerasStreamHealthLiteSuspense<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasStreamHealthLiteSuspense<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCamerasStreamHealthLiteSuspense<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary SSE stream of camera health-lite snapshots.
 */

export function useCamerasStreamHealthLiteSuspense<
  TData = Awaited<ReturnType<typeof camerasStreamHealthLite>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof camerasStreamHealthLite>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCamerasStreamHealthLiteSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getV1CamerasIdIntegrityResponse200 = {
  data: void;
  status: 200;
};

export type getV1CamerasIdIntegrityResponseSuccess = getV1CamerasIdIntegrityResponse200 & {
  headers: Headers;
};

export type getV1CamerasIdIntegrityResponse = getV1CamerasIdIntegrityResponseSuccess;

export const getGetV1CamerasIdIntegrityUrl = (id: string) => {
  return `/v1/cameras/${id}/integrity`;
};

export const getV1CamerasIdIntegrity = async (
  id: string,
  options?: RequestInit,
): Promise<getV1CamerasIdIntegrityResponse> => {
  return cguardFetcher<getV1CamerasIdIntegrityResponse>(getGetV1CamerasIdIntegrityUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1CamerasIdIntegrityQueryKey = (id: string) => {
  return [`/v1/cameras/${id}/integrity`] as const;
};

export const getGetV1CamerasIdIntegrityQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasIdIntegrityQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>> = ({
    signal,
  }) => getV1CamerasIdIntegrity(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasIdIntegrityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>
>;
export type GetV1CamerasIdIntegrityQueryError = unknown;

export function useGetV1CamerasIdIntegrity<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
          TError,
          Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdIntegrity<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
          TError,
          Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdIntegrity<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1CamerasIdIntegrity<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasIdIntegrityQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1CamerasIdIntegritySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1CamerasIdIntegrityQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>> = ({
    signal,
  }) => getV1CamerasIdIntegrity(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CamerasIdIntegritySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>
>;
export type GetV1CamerasIdIntegritySuspenseQueryError = unknown;

export function useGetV1CamerasIdIntegritySuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdIntegritySuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1CamerasIdIntegritySuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1CamerasIdIntegritySuspense<
  TData = Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1CamerasIdIntegrity>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1CamerasIdIntegritySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postV1CamerasIdIntegrityReviewOperationResponse200 = {
  data: void;
  status: 200;
};

export type postV1CamerasIdIntegrityReviewOperationResponseSuccess =
  postV1CamerasIdIntegrityReviewOperationResponse200 & {
    headers: Headers;
  };

export type postV1CamerasIdIntegrityReviewOperationResponse =
  postV1CamerasIdIntegrityReviewOperationResponseSuccess;

export const getPostV1CamerasIdIntegrityReviewOperationUrl = (id: string, operation: string) => {
  return `/v1/cameras/${id}/integrity/review/${operation}`;
};

export const postV1CamerasIdIntegrityReviewOperation = async (
  id: string,
  operation: string,
  changeRequest: ChangeRequest,
  options?: RequestInit,
): Promise<postV1CamerasIdIntegrityReviewOperationResponse> => {
  return cguardFetcher<postV1CamerasIdIntegrityReviewOperationResponse>(
    getPostV1CamerasIdIntegrityReviewOperationUrl(id, operation),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changeRequest),
    },
  );
};

export const getPostV1CamerasIdIntegrityReviewOperationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>,
    TError,
    { id: string; operation: string; data: ChangeRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>,
  TError,
  { id: string; operation: string; data: ChangeRequest },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdIntegrityReviewOperation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>,
    { id: string; operation: string; data: ChangeRequest }
  > = (props) => {
    const { id, operation, data } = props ?? {};

    return postV1CamerasIdIntegrityReviewOperation(id, operation, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdIntegrityReviewOperationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>
>;
export type PostV1CamerasIdIntegrityReviewOperationMutationBody = ChangeRequest;
export type PostV1CamerasIdIntegrityReviewOperationMutationError = unknown;

export const usePostV1CamerasIdIntegrityReviewOperation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>,
      TError,
      { id: string; operation: string; data: ChangeRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityReviewOperation>>,
  TError,
  { id: string; operation: string; data: ChangeRequest },
  TContext
> => {
  return useMutation(
    getPostV1CamerasIdIntegrityReviewOperationMutationOptions(options),
    queryClient,
  );
};
export type postV1CamerasIdIntegrityOperationResponse200 = {
  data: void;
  status: 200;
};

export type postV1CamerasIdIntegrityOperationResponseSuccess =
  postV1CamerasIdIntegrityOperationResponse200 & {
    headers: Headers;
  };

export type postV1CamerasIdIntegrityOperationResponse =
  postV1CamerasIdIntegrityOperationResponseSuccess;

export const getPostV1CamerasIdIntegrityOperationUrl = (id: string, operation: string) => {
  return `/v1/cameras/${id}/integrity/${operation}`;
};

export const postV1CamerasIdIntegrityOperation = async (
  id: string,
  operation: string,
  changeRequest: ChangeRequest,
  options?: RequestInit,
): Promise<postV1CamerasIdIntegrityOperationResponse> => {
  return cguardFetcher<postV1CamerasIdIntegrityOperationResponse>(
    getPostV1CamerasIdIntegrityOperationUrl(id, operation),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(changeRequest),
    },
  );
};

export const getPostV1CamerasIdIntegrityOperationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>,
    TError,
    { id: string; operation: string; data: ChangeRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>,
  TError,
  { id: string; operation: string; data: ChangeRequest },
  TContext
> => {
  const mutationKey = ['postV1CamerasIdIntegrityOperation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>,
    { id: string; operation: string; data: ChangeRequest }
  > = (props) => {
    const { id, operation, data } = props ?? {};

    return postV1CamerasIdIntegrityOperation(id, operation, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CamerasIdIntegrityOperationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>
>;
export type PostV1CamerasIdIntegrityOperationMutationBody = ChangeRequest;
export type PostV1CamerasIdIntegrityOperationMutationError = unknown;

export const usePostV1CamerasIdIntegrityOperation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>,
      TError,
      { id: string; operation: string; data: ChangeRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CamerasIdIntegrityOperation>>,
  TError,
  { id: string; operation: string; data: ChangeRequest },
  TContext
> => {
  return useMutation(getPostV1CamerasIdIntegrityOperationMutationOptions(options), queryClient);
};
